import state from './moduleAiJobState.js'
import mutations from './moduleAiJobMutations.js'
import actions from './moduleAiJobActions.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
}
